// import React, { Component } from 'react';
// // import 'react-sticky-header/styles.css';
// // import StickyHeader from 'react-sticky-header';

// import RegistrationCvHeaderComponent from '../common/header/registration-cv-header/RegistrationCvHeaderComponent';
// import HomeFooterComponent from '../common/footer/homefooter/HomeFooterView';

// class CvLayout extends Component {
//     state = {
//         sticky_header: 'innarpage-header',
//         inner_sticky: ''

//     }

//     componentDidMount() {
//         if (window.location.pathname != '/home') {
//             this.setState({
//                 sticky_header: 'innarpage-header',
//                 inner_sticky: 'inner-body-section'
//             })
//         }
//     }


//     onSticky = (isStiky) => {
//         const cstate = window.location.pathname != '/home';

//         if (isStiky) {
//             this.setState({
//                 sticky_header: 'innarpage-header fixed',
//                 inner_sticky: (cstate) ? 'inner-body-section-sort' : ''
//             })
//         } else {
//             this.setState({
//                 sticky_header: 'innarpage-header',
//                 inner_sticky: (cstate) ? 'inner-body-section' : ''
//             })
//         }
//     }
//     render() {
//         return (
//             <>
//                 {/* <StickyHeader header={<RegistrationCvHeaderComponent sticky={this.state.sticky_header} />} onSticky={this.onSticky}>
//                     <div className="header_end"></div>
//                 </StickyHeader> */}
//                 <div className={this.state.inner_sticky}>
//                     {this.props.children}
//                 </div>
//                 <HomeFooterComponent />
//             </>
//         )
//     }
// }



// export default CvLayout;






import React from 'react';
import { useEffect } from "react";
import HomeFooterComponent from '../common/footer/homefooter/HomeFooterView';
import RegistrationCvHeaderComponent from '../common/header/registration-cv-header/RegistrationCvHeaderComponent';

function CvLayout(props) {

    useEffect(() => {

      const header = document.getElementById("myHeader");
      const sticky = header.offsetTop;
      const scrollCallBack = window.addEventListener("scroll", () => {
        if (window.pageYOffset > sticky) {
          header.classList.add("dashboard__sticky");
        } else {
          header.classList.remove("dashboard__sticky");
        }
      });
      return () => {
        window.removeEventListener("scroll", scrollCallBack);
      };
    }, []);
  
    return (
      <div>
        <header id="myHeader" className="dashboard__header">
        <RegistrationCvHeaderComponent  />
        </header>
        <div className='inner-body-section'>
                     {props.children}
                 </div>
        {/* <HomeFooterComponent /> */}
      </div>
    );
  }
  
  export default CvLayout;
  
